var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login mainWrap"
  }, [_c('p', {
    staticClass: "loginTitle bold mb-0 mt-3"
  }, [_vm._v("助成業務支援システム")]), _c('p', {
    staticClass: "loginSubTitle mb-0",
    class: {
      'text-danger': _vm.isCms
    }
  }, [_vm._v(_vm._s(_vm.subTitle))]), _vm.viewRegister ? _c('p', {
    staticClass: "mb-1 mt-4"
  }, [_vm._v("アカウント作成時に登録されたメールアドレス・パスワードを入力してください。")]) : _vm._e(), _c('p', {
    class: [_vm.viewRegister ? '' : 'mt-4', 'mb-1']
  }, [_vm._v("ログインは認証成功後、12時間有効です。")]), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("一定時間内にパスワードの認証に5回失敗した場合、24時間ログインできなくなります。")]), _c('b-form', {
    staticClass: "w-50",
    attrs: {
      "id": "loginWrap"
    }
  }, [_c('label', {
    staticClass: "bold",
    attrs: {
      "for": "input-default"
    }
  }, [_vm._v("メールアドレス")]), _c('b-form-input', {
    staticClass: "mb-3 h-50px",
    attrs: {
      "size": "md",
      "autocomplete": 'email'
    },
    model: {
      value: _vm.id,
      callback: function callback($$v) {
        _vm.id = $$v;
      },
      expression: "id"
    }
  }), _c('label', {
    staticClass: "bold",
    attrs: {
      "for": "input-default"
    }
  }, [_vm._v("パスワード")]), _c('div', {
    staticClass: "password-input-wrapper mb-4"
  }, [_c('b-form-input', {
    staticClass: "h-50px login-password-input",
    attrs: {
      "type": _vm.isPasswordVisible ? 'text' : 'password',
      "maxlength": "255",
      "autocomplete": 'current-password'
    },
    model: {
      value: _vm.password,
      callback: function callback($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }), _c('button', {
    staticClass: "password-toggle-btn",
    attrs: {
      "type": "button",
      "aria-label": _vm.isPasswordVisible ? 'パスワードを非表示にする' : 'パスワードを表示する'
    },
    on: {
      "click": function click($event) {
        _vm.isPasswordVisible = !_vm.isPasswordVisible;
      }
    }
  }, [_c('unicon', {
    attrs: {
      "name": _vm.isPasswordVisible ? 'eye-slash' : 'eye',
      "fill": "#495057"
    }
  })], 1)], 1), _c('div', {
    staticClass: "bottonArea flex flexCenter"
  }, [_c('b-button', {
    staticClass: "w-100 boldBtn",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.kickLogin
    }
  }, [_vm._v("ログイン")])], 1), _c('b-alert', {
    staticClass: "mt-3",
    attrs: {
      "show": _vm.errorMsg !== '',
      "variant": "warning"
    }
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _c('b-alert', {
    staticClass: "mt-3",
    attrs: {
      "show": _vm.isFinalWarning,
      "variant": "danger"
    }
  }, [_vm._v("※次回失敗すると24時間ログインできなくなります。")]), _vm.viewResetPass ? _c('div', [_c('p', {
    staticClass: "mt-4"
  }, [_c('img', {
    staticClass: "tri",
    attrs: {
      "src": require("@/assets/svg/tri.svg")
    }
  }), _c('b-link', {
    staticClass: "ml-1",
    attrs: {
      "to": _vm.resetPassUrl
    }
  }, [_vm._v("パスワードを忘れた場合")])], 1)]) : _vm._e(), _vm.viewRegister ? _c('div', [_c('hr', {
    staticClass: "my-4"
  }), _c('div', {
    staticClass: "bottonArea flex flexCenter",
    attrs: {
      "id": "newAccount"
    }
  }, [_c('b-button', {
    staticClass: "w-100 boldBtn",
    on: {
      "click": _vm.goInitMail
    }
  }, [_vm._v("新しくアカウントを作成")])], 1)]) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };